import {AdminScope} from 'modules/admin/models/AdminScope';

export interface RouterParams {
  campaignId: string;
  fieldId: string;
  serviceId: ServiceId;
  viewId: ServiceView;
  adminScope: AdminScope;
}

export enum ServiceView {
  /**
   * Vegetation service view
   */
  DATE_COMPARISON = 'date-comparison',
  FIELD_COMPARISON = 'field-comparison',
  VEGETATION_DEVELOPPMENT = 'vegetation-development',

  /**
   * Carbon service view
   */
  BARE_SOIL = 'bare-soil',
  COVER_SOIL = 'cover-soil',

  /**
   * Nitrogen service view
   */
  NITROGEN_COVER = 'nitrogen-cover',
  RECOMMENDATION = 'recommendation',
  FERTILIZATION = 'fertilization',

  /**
   * Weather service view
   */
  WEATHER_OVERVIEW = 'overview',
  WEATHER_ACCUMULATION = 'accumulation',
  WEATHER_WEEK = 'week',

  /**
   * Irrigation service view
   */
  GENERAL_VIEW = 'general-view',
  REVIEW = 'review',
  IRRIGATION = 'analyze',
  WATERBALANCE = 'water-balance',
  EVAPOTRANSPIRATION = 'evapotranspiration',

  /**
   * Visio Crop service view
   */
  PROCESSES = 'processes',

  /**
   * Common view
   */
  EDIT = 'edit',
  MAP = 'map',
  STATISTICS = 'statistics',

  /**
   * Admin report view
   */
  REPORT = 'report_list',
  REPORT_ERROR = 'report_error',

  /**
   * Campaign Resume view
   */
  CAMPAIGN_REPORT_ORDER = 'campaign_order',
  CAMPAIGN_REPORT_EXPLOITATIONS = 'campaign_exploitations',

  /**
   * Admin contracts view
   */
  CONTRACTS = 'contracts',
  SUBSCRIPTIONS = 'subscriptions',
}

export enum ServiceId {
  IRRIGATION = 'irrigation',
  NITROGEN = 'nitrogen',
  CARBON = 'carbon',
  WEATHER = 'weather',
  VEGETATION = 'vegetation',
  ADMIN = 'admin',
  VISIO_CROP = 'visio-crop',
  FIELDS = 'fields-parameters',
  SERVICES = 'services',
  SOILS = 'soils',
  CROPS = 'crops',
}
